import { render } from "./team-box.vue?vue&type=template&id=a2f279d0&scoped=true"
import script from "./team-box.vue?vue&type=script&lang=js"
export * from "./team-box.vue?vue&type=script&lang=js"

import "./team-box.vue?vue&type=style&index=0&id=a2f279d0&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f279d0"]])

export default __exports__